
export class TimeoutManager {
  private timeoutIds = [];
  private intervalIds = [];

  timeout(callback: Function, time: number = 0) {
    this.timeoutIds.push(setTimeout(callback, time));
  }

  interval(callback: Function, time: number = 10) {
    this.intervalIds.push(setInterval(callback, time));
  }

  clear() {
    this.timeoutIds.forEach(x => clearTimeout(x));
    this.timeoutIds = [];
    this.intervalIds.forEach(x => clearInterval(x));
    this.intervalIds = [];
  }
}
